// src/pages/admin/FetchFailedHelp.js

import React, { useEffect, useState } from "react";

const FetchFailedHelp = () => {
  const [bounce, setBounce] = useState(false);
  const [tailWag, setTailWag] = useState(0);
  const [eyeBlink, setEyeBlink] = useState(false);
  const [stars, setStars] = useState([]);
  const [pawPrints, setPawPrints] = useState([]);

  useEffect(() => {
    // Tail wag animation
    const wagInterval = setInterval(() => {
      setTailWag((prev) => (prev + 1) % 3);
    }, 300);

    // Blink animation
    const blinkInterval = setInterval(() => {
      setEyeBlink(true);
      setTimeout(() => setEyeBlink(false), 150);
    }, 3000);

    // Bounce
    const bounceInterval = setInterval(() => {
      setBounce(true);
      setTimeout(() => setBounce(false), 600);
    }, 2000);

    // Generate floating stars
    setStars(
      Array.from({ length: 18 }, (_, i) => ({
        id: i,
        left: Math.random() * 100,
        top: Math.random() * 100,
        size: Math.random() * 14 + 8,
        delay: Math.random() * 3,
        duration: Math.random() * 2 + 2,
        color: [
          "#FFD700",
          "#FF6B9D",
          "#A8EDEA",
          "#FFA07A",
          "#98FB98",
          "#DDA0DD",
        ][Math.floor(Math.random() * 6)],
      })),
    );

    // Paw prints trail
    setPawPrints(
      Array.from({ length: 6 }, (_, i) => ({
        id: i,
        left: 8 + i * 14,
        bottom: 6 + (i % 2) * 4,
        delay: i * 0.3,
        rotate: -10 + i * 5,
      })),
    );

    return () => {
      clearInterval(wagInterval);
      clearInterval(blinkInterval);
      clearInterval(bounceInterval);
    };
  }, []);

  const tailRotations = [-30, 0, 30];

  const styles = `
    @import url('https://fonts.googleapis.com/css2?family=Baloo+2:wght@400;700;800;900&family=Nunito:wght@400;600;700;900&display=swap');

    * { box-sizing: border-box; margin: 0; padding: 0; }

    .page-wrap {
      min-height: 100vh;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-family: 'Nunito', sans-serif;
      overflow: hidden;
      position: relative;
      padding: 20px;
    }

    .floating-star {
      position: fixed;
      pointer-events: none;
      animation: floatStar var(--dur) ease-in-out var(--delay) infinite alternate;
      z-index: 0;
      filter: drop-shadow(0 0 6px currentColor);
    }

    @keyframes floatStar {
      0% { transform: translateY(0) rotate(0deg) scale(1); opacity: 0.6; }
      100% { transform: translateY(-20px) rotate(25deg) scale(1.2); opacity: 1; }
    }

    .main-card {
      position: relative;
      z-index: 1;
      text-align: center;
      max-width: 560px;
      width: 100%;
      padding: 48px 40px 40px;
      border-radius: 32px;
      background: rgba(255,255,255,0.72);
      backdrop-filter: blur(16px);
      box-shadow:
        0 0 0 3px rgba(255,182,193,0.5),
        0 20px 60px rgba(255,105,180,0.18),
        0 4px 16px rgba(0,0,0,0.07);
      animation: cardPop 0.8s cubic-bezier(0.34,1.56,0.64,1) both;
    }

    @keyframes cardPop {
      0% { opacity: 0; transform: scale(0.6) translateY(40px); }
      100% { opacity: 1; transform: scale(1) translateY(0); }
    }

    .num-404 {
      font-family: 'Baloo 2', cursive;
      font-size: clamp(80px, 18vw, 130px);
      font-weight: 900;
      line-height: 1;
      background: linear-gradient(135deg, #FF6B9D 0%, #FF8C42 40%, #FFD93D 80%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      letter-spacing: -4px;
      animation: shimmer 3s ease-in-out infinite alternate;
      filter: drop-shadow(0 4px 12px rgba(255,107,157,0.3));
    }

    @keyframes shimmer {
      0% { filter: drop-shadow(0 4px 12px rgba(255,107,157,0.3)) brightness(1); }
      100% { filter: drop-shadow(0 4px 20px rgba(255,140,66,0.5)) brightness(1.1); }
    }

    .dog-container {
      position: relative;
      display: inline-block;
      margin: 16px 0 24px;
      animation: dogBounce 0.6s cubic-bezier(0.36,0.07,0.19,0.97) both;
      animation-play-state: var(--bounce-state, paused);
    }

    .dog-container.bouncing {
      animation: dogJump 0.6s ease both;
    }

    @keyframes dogJump {
      0%, 100% { transform: translateY(0) rotate(0deg); }
      30% { transform: translateY(-18px) rotate(-4deg); }
      60% { transform: translateY(-10px) rotate(3deg); }
    }

    .dog-svg {
      width: 180px;
      height: 180px;
      filter: drop-shadow(0 8px 20px rgba(0,0,0,0.15));
    }

    .eye-blink rect, .eye-blink ellipse {
      transform-origin: center;
    }

    .omg-badge {
      position: absolute;
      top: -10px;
      right: -20px;
      background: linear-gradient(135deg, #FF6B9D, #FF8C42);
      color: white;
      font-family: 'Baloo 2', cursive;
      font-size: 11px;
      font-weight: 800;
      padding: 5px 10px;
      border-radius: 20px;
      white-space: nowrap;
      transform: rotate(12deg);
      box-shadow: 0 4px 12px rgba(255,107,157,0.5);
      animation: badgePulse 1.5s ease-in-out infinite;
    }

    @keyframes badgePulse {
      0%, 100% { transform: rotate(12deg) scale(1); }
      50% { transform: rotate(12deg) scale(1.08); }
    }

    .title-text {
      font-family: 'Baloo 2', cursive;
      font-size: clamp(22px, 5vw, 32px);
      font-weight: 800;
      color: #3D2B5E;
      margin-bottom: 8px;
      animation: slideUp 0.8s 0.3s cubic-bezier(0.34,1.56,0.64,1) both;
    }

    .sub-text {
      font-size: 15px;
      font-weight: 600;
      color: #9B8BB4;
      margin-bottom: 28px;
      animation: slideUp 0.8s 0.45s cubic-bezier(0.34,1.56,0.64,1) both;
    }

    @keyframes slideUp {
      0% { opacity: 0; transform: translateY(20px); }
      100% { opacity: 1; transform: translateY(0); }
    }

    .btn-home {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      padding: 14px 32px;
      border-radius: 50px;
      border: none;
      cursor: pointer;
      font-family: 'Baloo 2', cursive;
      font-size: 16px;
      font-weight: 800;
      color: white;
      background: linear-gradient(135deg, #FF6B9D 0%, #FF8C42 100%);
      box-shadow: 0 6px 24px rgba(255,107,157,0.45);
      transition: transform 0.2s, box-shadow 0.2s;
      animation: slideUp 0.8s 0.6s cubic-bezier(0.34,1.56,0.64,1) both;
      text-decoration: none;
    }

    .btn-home:hover {
      transform: translateY(-3px) scale(1.04);
      box-shadow: 0 10px 32px rgba(255,107,157,0.55);
    }

    .btn-home:active {
      transform: translateY(1px) scale(0.98);
    }

    .paw-trail {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 40px;
      overflow: hidden;
      pointer-events: none;
    }

    .paw {
      position: absolute;
      opacity: 0;
      animation: pawAppear 0.5s ease forwards;
      animation-delay: var(--paw-delay);
    }

    @keyframes pawAppear {
      0% { opacity: 0; transform: scale(0) rotate(var(--paw-rot)); }
      60% { opacity: 0.5; transform: scale(1.1) rotate(var(--paw-rot)); }
      100% { opacity: 0.25; transform: scale(1) rotate(var(--paw-rot)); }
    }

    .speech-bubble {
      position: absolute;
      top: -55px;
      left: 50%;
      transform: translateX(-50%);
      background: white;
      border: 2.5px solid #FFB3D1;
      border-radius: 16px;
      padding: 8px 14px;
      font-size: 13px;
      font-weight: 700;
      color: #FF6B9D;
      white-space: nowrap;
      box-shadow: 0 4px 12px rgba(255,179,209,0.4);
      animation: speechPop 2s 1s ease both;
    }

    .speech-bubble::after {
      content: '';
      position: absolute;
      bottom: -10px;
      left: 50%;
      transform: translateX(-50%);
      border: 5px solid transparent;
      border-top-color: #FFB3D1;
    }

    @keyframes speechPop {
      0% { opacity: 0; transform: translateX(-50%) scale(0.5); }
      20% { opacity: 1; transform: translateX(-50%) scale(1.05); }
      30% { transform: translateX(-50%) scale(1); }
      80% { opacity: 1; }
      100% { opacity: 1; transform: translateX(-50%) scale(1); }
    }

    .hearts {
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      pointer-events: none;
      overflow: hidden;
      border-radius: 32px;
    }

    .heart {
      position: absolute;
      font-size: 18px;
      animation: floatHeart var(--h-dur) ease-in var(--h-delay) infinite;
      opacity: 0;
    }

    @keyframes floatHeart {
      0% { opacity: 0; transform: translateY(0) scale(0.5); }
      20% { opacity: 0.8; transform: translateY(-20px) scale(1); }
      80% { opacity: 0.4; }
      100% { opacity: 0; transform: translateY(-80px) scale(0.8); }
    }

    .emoji-row {
      font-size: 22px;
      margin-bottom: 12px;
      animation: slideUp 0.8s 0.2s both;
      letter-spacing: 4px;
    }

    .squiggle {
      display: block;
      margin: 0 auto 20px;
      animation: slideUp 0.8s 0.35s both;
    }
  `;

  const tailTransform = `rotate(${tailRotations[tailWag]}deg)`;
  const eyeScaleY = eyeBlink ? 0.05 : 1;

  return (
    <>
      <style>{styles}</style>

      {/* Floating stars */}
      {stars.map((s) => (
        <div
          key={s.id}
          className="floating-star"
          style={{
            left: `${s.left}%`,
            top: `${s.top}%`,
            color: s.color,
            fontSize: s.size,
            "--dur": `${s.duration}s`,
            "--delay": `${s.delay}s`,
          }}
        >
          ✦
        </div>
      ))}

      <div className="page-wrap">
        <div className="main-card">
          {/* Floating hearts in background */}
          <div className="hearts">
            {[...Array(6)].map((_, i) => (
              <div
                key={i}
                className="heart"
                style={{
                  left: `${10 + i * 15}%`,
                  bottom: "10%",
                  "--h-dur": `${2 + i * 0.4}s`,
                  "--h-delay": `${i * 0.6}s`,
                }}
              >
                {["💕", "🌸", "✨", "💖", "🎀", "⭐"][i]}
              </div>
            ))}
          </div>

          <div className="num-404">404</div>

          {/* Dog illustration */}
          <div
            className={`dog-container ${bounce ? "bouncing" : ""}`}
            style={{ position: "relative" }}
          >
            <div className="speech-bubble">Woof?? Where am I?! 🐾</div>

            <div className="omg-badge">OMG!! 😱</div>

            <svg
              className="dog-svg"
              viewBox="0 0 200 200"
              xmlns="http://www.w3.org/2000/svg"
            >
              {/* Body */}
              <ellipse cx="100" cy="145" rx="42" ry="35" fill="#3D2B1F" />

              {/* Belly patch */}
              <ellipse cx="100" cy="150" rx="22" ry="20" fill="#C8A882" />

              {/* Front legs */}
              <rect
                x="70"
                y="162"
                width="14"
                height="28"
                rx="7"
                fill="#3D2B1F"
              />
              <rect
                x="116"
                y="162"
                width="14"
                height="28"
                rx="7"
                fill="#3D2B1F"
              />

              {/* Paws */}
              <ellipse cx="77" cy="191" rx="8" ry="5" fill="#2A1A10" />
              <ellipse cx="123" cy="191" rx="8" ry="5" fill="#2A1A10" />

              {/* Tail */}
              <g
                style={{
                  transformOrigin: "160px 145px",
                  transform: tailTransform,
                  transition: "transform 0.2s ease",
                }}
              >
                <path
                  d="M 142 140 Q 168 125 172 110 Q 176 100 165 105"
                  stroke="#3D2B1F"
                  strokeWidth="10"
                  strokeLinecap="round"
                  fill="none"
                />
              </g>

              {/* Neck */}
              <rect
                x="85"
                y="108"
                width="30"
                height="24"
                rx="10"
                fill="#3D2B1F"
              />

              {/* Head */}
              <ellipse cx="100" cy="95" rx="36" ry="32" fill="#3D2B1F" />

              {/* Head tan patches */}
              <ellipse cx="100" cy="102" rx="18" ry="14" fill="#C8A882" />

              {/* Ear left - pointy doberman */}
              <polygon points="68,72 60,38 82,65" fill="#2A1A10" />
              <polygon points="70,70 64,44 80,66" fill="#3D2B1F" />

              {/* Ear right */}
              <polygon points="132,72 140,38 118,65" fill="#2A1A10" />
              <polygon points="130,70 136,44 120,66" fill="#3D2B1F" />

              {/* Forehead tan patch */}
              <ellipse cx="100" cy="82" rx="12" ry="9" fill="#C8A882" />

              {/* Eyes */}
              <g>
                {/* Left eye */}
                <ellipse cx="87" cy="88" rx="7" ry="7" fill="white" />
                <ellipse
                  cx="87"
                  cy="88"
                  rx="5"
                  ry={eyeBlink ? 0.3 : 5}
                  fill="#1a0a00"
                  style={{ transition: "ry 0.05s" }}
                />
                {!eyeBlink && (
                  <ellipse cx="89" cy="86" rx="1.5" ry="1.5" fill="white" />
                )}
                {/* Eyelashes left */}
                <line
                  x1="82"
                  y1="83"
                  x2="80"
                  y2="80"
                  stroke="#1a0a00"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <line
                  x1="87"
                  y1="82"
                  x2="86"
                  y2="79"
                  stroke="#1a0a00"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <line
                  x1="92"
                  y1="83"
                  x2="93"
                  y2="80"
                  stroke="#1a0a00"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
              </g>

              <g>
                {/* Right eye */}
                <ellipse cx="113" cy="88" rx="7" ry="7" fill="white" />
                <ellipse
                  cx="113"
                  cy="88"
                  rx="5"
                  ry={eyeBlink ? 0.3 : 5}
                  fill="#1a0a00"
                  style={{ transition: "ry 0.05s" }}
                />
                {!eyeBlink && (
                  <ellipse cx="115" cy="86" rx="1.5" ry="1.5" fill="white" />
                )}
                <line
                  x1="108"
                  y1="83"
                  x2="107"
                  y2="80"
                  stroke="#1a0a00"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <line
                  x1="113"
                  y1="82"
                  x2="113"
                  y2="79"
                  stroke="#1a0a00"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <line
                  x1="118"
                  y1="83"
                  x2="120"
                  y2="80"
                  stroke="#1a0a00"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
              </g>

              {/* Eyebrow marks (tan) */}
              <ellipse cx="87" cy="78" rx="5" ry="2.5" fill="#C8A882" />
              <ellipse cx="113" cy="78" rx="5" ry="2.5" fill="#C8A882" />

              {/* Snout */}
              <ellipse cx="100" cy="103" rx="12" ry="10" fill="#C8A882" />
              {/* Nose */}
              <ellipse cx="100" cy="98" rx="6" ry="4" fill="#1a0a00" />
              <ellipse
                cx="101"
                cy="97"
                rx="1.5"
                ry="1"
                fill="rgba(255,255,255,0.5)"
              />

              {/* Mouth - cute smile */}
              <path
                d="M 93 107 Q 100 114 107 107"
                stroke="#a06040"
                strokeWidth="2"
                strokeLinecap="round"
                fill="none"
              />

              {/* Tongue out */}
              <ellipse cx="100" cy="112" rx="5" ry="7" fill="#FF6B9D" />
              <line
                x1="100"
                y1="108"
                x2="100"
                y2="118"
                stroke="#e05588"
                strokeWidth="1.5"
              />

              {/* Blush circles */}
              <ellipse
                cx="80"
                cy="100"
                rx="6"
                ry="4"
                fill="#FFB3D1"
                opacity="0.6"
              />
              <ellipse
                cx="120"
                cy="100"
                rx="6"
                ry="4"
                fill="#FFB3D1"
                opacity="0.6"
              />

              {/* Collar */}
              <rect
                x="83"
                y="120"
                width="34"
                height="9"
                rx="4.5"
                fill="#FF6B9D"
              />
              <circle cx="100" cy="124" r="3" fill="#FFD700" />

              {/* Stars around head */}
              <text x="52" y="75" fontSize="14" fill="#FFD700">
                ✦
              </text>
              <text x="140" y="70" fontSize="11" fill="#FF6B9D">
                ✦
              </text>
              <text x="148" y="90" fontSize="9" fill="#98FB98">
                ★
              </text>
              <text x="44" y="95" fontSize="9" fill="#DDA0DD">
                ★
              </text>
            </svg>

            {/* Paw prints trail */}
            <div className="paw-trail">
              {pawPrints.map((p) => (
                <div
                  key={p.id}
                  className="paw"
                  style={{
                    left: `${p.left}%`,
                    bottom: `${p.bottom}%`,
                    "--paw-delay": `${p.delay}s`,
                    "--paw-rot": `${p.rotate}deg`,
                    fontSize: 16,
                  }}
                >
                  🐾
                </div>
              ))}
            </div>
          </div>

          {/* Text */}
          <div className="emoji-row">😵 🗺️ 🐾</div>

          <svg
            className="squiggle"
            width="180"
            height="12"
            viewBox="0 0 180 12"
          >
            <path
              d="M 0 6 Q 15 0 30 6 Q 45 12 60 6 Q 75 0 90 6 Q 105 12 120 6 Q 135 0 150 6 Q 165 12 180 6"
              stroke="#FFB3D1"
              strokeWidth="2.5"
              fill="none"
              strokeLinecap="round"
            />
          </svg>

          <h1 className="title-text">omg… I think I'm lost! 🥺</h1>
          <p className="sub-text">Sorry, this page could not be found 🌸</p>

          <a href="/" className="btn-home">
            🏠 Take me home!
          </a>
        </div>
      </div>
    </>
  );
};

export default FetchFailedHelp;
